'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constantize = function constantize(string) {
  if (string === null || string === undefined) return string;
  if (typeof string !== 'string') throw new Error('Input must be of type string');
  return string === null || string === void 0 ? void 0 : string.trim().replace(/-/g, '_').toUpperCase();
};

exports.constantize = constantize;
